/**
 * `/market/engagements` — search schema.
 *
 *   ?side=client|expert  which half of your engagements to show. Two lists, not
 *                        one merged one: «work I asked for» and «work I was
 *                        asked for» are different questions, and a merged list
 *                        makes the reader work out which is which per row.
 *
 * Anything else falls back to `client`, which is the side a person arrives on.
 */
import { createFileRoute } from '@tanstack/react-router';

export interface MarketEngagementsSearch {
  side?: 'client' | 'expert';
}

export function validateMarketEngagementsSearch(
  search: Record<string, unknown>,
): MarketEngagementsSearch {
  return { side: search?.side === 'expert' ? 'expert' : 'client' };
}

export const Route = createFileRoute('/_authenticated/market/engagements')({
  validateSearch: validateMarketEngagementsSearch,
});
